import { registerCondition } from 'core/forms';

const isNotScored = ({ model }) => ({
  condition: null,
  hasCondition: !['failed', 'passed'].includes(model.status),
});

registerCondition('isNotScored', isNotScored);

export default isNotScored;
